






























































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Policy } from '@/modules/Policy/interfaces/policy'
import { Endorsement, IEndorsementChange } from '@/modules/Policy/interfaces/endorsement'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { getPolicyEndorsements } from '@/modules/Policy/gql/endorsement.gql'
import { newCase } from '@/modules/Case/gql/case.gql'
import { endorsementKeyMap } from '@/modules/Policy/helpers/endorsement'
import AppDialog from '@/components/AppDialog.vue'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { User } from '@/modules/User/interfaces/user'
import { CaseType } from '@/modules/Case/interfaces/case'
import EndorsementDialog from '@/modules/Policy/components/EndorsementDialog.vue'
import { policyStatus, billingType } from '@/modules/Policy/helpers/policy'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    AppDialog,
    EndorsementDialog
  }
})
export default class PolicyDetailEndorsement extends Vue {
  @Prop({ type: Object as () => Policy }) policy!: Policy
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  endorsements: Endorsement[] = []

  changeContents: IEndorsementChange[] = []

  latestVersion: Endorsement | null = null

  endorsementDialog = {
    show: false
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  policyStatus = policyStatus
  billingType = billingType

  R = this.$R

  endorsementDetailDialog: {
    show: boolean;
    endorsement: null | Endorsement;
    changeContent: null | IEndorsementChange;
  } = {
    show: false,
    endorsement: null,
    changeContent: null
  }

  get ifOpenningCase () {
    const { openedCases } = this.policy

    for (const cs of openedCases) {
      if (cs.type === CaseType.ENDORSEMENT) {
        return true
      }
    }
    return false
  }

  @State(state => state.user.me) me!: User

  mounted () {
    this.parsePolicyTolatestVersion()
    this.getEndorsements()
  }

  @Watch('policy', { deep: true })
  onPolicyChanged () {
    this.parsePolicyTolatestVersion()
    this.getEndorsements()
  }

  @Watch('endorsements', { deep: true })
  onEndorsementsChanged (endorsements: Endorsement[]) {
    const { latestVersion } = this

    if (!latestVersion || !endorsements.length) return

    let oldVersion = endorsements[0]

    const changeContents = []

    for (let i = 1; i < endorsements.length; i++) {
      const item = endorsements[i]

      const changeContent = this.compareChanges(oldVersion, item)
      oldVersion = endorsements[i]
      changeContents.push(this.$R.filter((val: boolean) => val, changeContent))
    }

    changeContents.push(this.$R.filter(
      (val: boolean) => val,
      this.compareChanges(oldVersion, latestVersion)
    ))

    this.changeContents = changeContents
  }

  parsePolicyTolatestVersion () {
    const { policy } = this
    if (!policy) {
      return
    }

    this.latestVersion = {
      id: -1,
      policyId: policy.id,
      policyName: policy.policyName,
      status: policy.status,
      type: policy.type,
      effectiveDate: policy.effectiveDate,
      expirationDate: policy.expirationDate,
      originalInceptionDate: policy.originalInceptionDate,
      brokerFee: policy.brokerFee,
      agencyFee: policy.agencyFee,
      carrierPolicyFee: policy.carrierPolicyFee,
      inspectionFee: policy.inspectionFee,
      taxesFee: policy.taxesFee,
      stampingFee: policy.stampingFee,
      premium: policy.premium,
      policyNumber: policy.policyNumber,
      term: policy.term,
      closed: policy.closed,
      cancelDate: policy.cancelDate,
      createdAt: policy.createdAt,
      updatedAt: policy.updatedAt,
      additionalInfoStr: policy.additionalInfoStr,
      installmentPlan: policy.installmentPlan,
      billingType: policy.billingType,
      totalProjectedPremium: policy.totalProjectedPremium,
      totalProjectedCommission: policy.totalProjectedCommission,
      productCommissionOverride: policy.productCommissionOverride,
      federalEmployerIdNumber: policy.federalEmployerIdNumber,
      nonRenew: policy.nonRenew,
      shouldAutoCancel: policy.shouldAutoCancel,
      book: policy.book,
      account: policy.account,
      primaryContact: policy.primaryContact,
      source: policy.source,
      carrier: policy.carrier,
      carrierProduct: policy.carrierProduct,
      generalAgent: policy.generalAgent,
      recordType: policy.recordType,
      insuranceQuote: policy.insuranceQuote,
      note: '',
      createdBy: policy.createdBy
    }
  }

  compareChanges (oldVersion: any, newVal: any) {
    const { date, fee, object, other, bool } = endorsementKeyMap
    const dateKeys = this.$R.keys(date)
    const feeKeys = this.$R.keys(fee)
    const objectKeys = this.$R.keys(object)
    const boolKeys = this.$R.keys(bool)
    const otherKeys = this.$R.keys(other)
    const keys = this.$R.keys(newVal)

    let changeContent: any = {}
    for (const key of keys) {
      switch (true) {
        case key === 'additionalInfoStr':
          changeContent = {
            ...changeContent,
            ...this.parseAdditional(oldVersion.additionalInfoStr, newVal[key])
          }
          break
        case this.$R.contains(key, objectKeys):
          if (!this.ifSameObject(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: object[key],
              from: oldVersion[key] ? oldVersion[key].name : '-',
              to: newVal[key] ? newVal[key].name : '-'
            }
          }
          break
        case this.$R.contains(key, dateKeys):
          if (!this.ifSameDate(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: date[key],
              from: oldVersion[key] ? dateToDisplay(oldVersion[key]) : '-',
              to: newVal[key] ? dateToDisplay(newVal[key]) : '-'
            }
          }
          break
        case this.$R.contains(key, feeKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: fee[key],
              from: oldVersion[key] ? dollarFilter(oldVersion[key]) : '$ 0',
              to: newVal[key] ? dollarFilter(newVal[key]) : '-'
            }
          }
          break
        case this.$R.contains(key, boolKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: bool[key],
              from: oldVersion[key] ? 'yes' : 'no',
              to: newVal[key] ? 'yes' : 'no'
            }
          }
          break
        case key === 'status':
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: 'Status',
              from: oldVersion[key] ? policyStatus[oldVersion[key]] : '-',
              to: newVal[key] ? policyStatus[newVal[key]] : '-'
            }
          }
          break
        case key === 'billingType':
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: 'Billing Type',
              from: oldVersion[key] ? policyStatus[oldVersion[key]] : '-',
              to: newVal[key] ? policyStatus[newVal[key]] : '-'
            }
          }
          break
        case this.$R.contains(key, otherKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: other[key],
              from: oldVersion[key] || '-',
              to: newVal[key] || '-'
            }
          }
          break
      }
    }

    return changeContent
  }

  parseAdditional (oldStr: string, newStr: string) {
    const { recordType } = this
    const newAdditionalInfo = JSON.parse(newStr)
    const old = JSON.parse(oldStr)
    const changeContents: any = {}
    const keyNameMap: any = {}

    for (const part of recordType.additionalInfo) {
      if (this.$R.contains(part.title, ['Base', 'Account Information', 'Carrier Information', 'Premium Information', 'Commission Information', 'Source Information'])) {
        continue
      }

      for (const item of part.items) {
        keyNameMap[item.keyName] = item.name
      }
    }

    for (let key of this.$R.keys(newAdditionalInfo)) {
      if (!keyNameMap[key]) {
        continue
      }

      if (!this.ifSameValue(old[key], newAdditionalInfo[key])) {
        changeContents[key] = {
          name: keyNameMap[key],
          from: old[key] || '-',
          to: newAdditionalInfo[key] || '-'
        }
      }
    }

    return changeContents
  }

  ifSameValue (oldVal: string, newVal: string) {
    return (!oldVal && !newVal) || (newVal === oldVal)
  }

  ifSameObject<T extends { id: number, name: string }> (oldVal: T, newVal: T) {
    return (!oldVal && !newVal) ||
      (oldVal && newVal && oldVal.id === newVal.id)
  }

  ifSameDate (oldVal: string, newVal: string) {
    return (!oldVal && !newVal) ||
      (dateToDisplay(oldVal) === dateToDisplay(newVal))
  }

  async getEndorsements () {
    if (!this.policy) {
      return
    }

    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getPolicyEndorsements,
        variables: {
          policyId: Number(this.policy.id)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.endorsements = result.data.getPolicyEndorsements
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newEndorsementCase () {
    const { policy } = this

    if (!policy) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: newCase,
        variables: {
          caseInput: {
            inquiryName: `${policy.policyName} Endorsement Case`,
            type: 'ENDORSEMENT',
            targetPolicyId: Number(policy.id),
            caseNote: `Endorsement case for policy: ${policy.policyName}`,
            recordTypeId: Number(policy.recordType.id),
            accountId: Number(policy.account.id),
            primaryContactId: policy.primaryContact ? Number(policy.primaryContact.id) : null,
            caseManagerId: Number(this.me.id),
            sourceId: policy.source ? Number(policy.source.id) : null
          }
        }
      })

      showNotification({
        msg: 'Create endorsement case successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.onSuccess()
  }

  showEndorsementDialog (e: Event) {
    e.preventDefault()
    e.stopPropagation()

    this.endorsementDialog.show = true
  }

  clickEndorsementHandler (index: number) {
    if (index >= this.endorsements.length) {
      return
    }
    const endorsement = this.endorsements[index] || null
    const changeContent = this.changeContents[index - 1] || null
    this.endorsementDetailDialog = {
      show: true,
      endorsement,
      changeContent
    }
  }

  parseEndorsementNote (note: string) {
    return note ? note.split('\n') : []
  }

  @Emit('success')
  onSuccess () {
    this.endorsementDialog.show = false
    this.getEndorsements()
  }

  onCancel () {
    this.endorsementDetailDialog = {
      show: false,
      endorsement: null,
      changeContent: null
    }
  }
}
